import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileHandle } from 'src/app/shared/directives/drag-drop.directive';
import { Stock } from 'src/app/shared/models/stock.model';
import { Subscription } from 'rxjs';
import { ImageUploadService } from './image-upload.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Purpose } from 'src/app/shared/models/purpose.model';
import { Resolution } from 'src/app/shared/models/resolution.model';
import { Title } from 'src/app/shared/models/title.model';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent implements OnInit, OnDestroy {

  files: FileHandle[];
  stocks: Stock[];
  purposes: Purpose[];
  resolutions: Resolution[];
  uploadForm: FormGroup;

  @Input() paramTitle: Title;
  @Input() paramStockId: Stock;

  private stocksSubscription: Subscription = null;
  private purposesSubscription: Subscription = null;
  private resolutionsSubscription: Subscription = null;

  constructor(public activeModal: NgbActiveModal,
    private imageUploadService: ImageUploadService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService) { }

  /**
   * OnInit
   */
  ngOnInit() {
    this.files = [];
    this.stocks = [];
    this.purposes = [];

    this.uploadForm = this.formBuilder.group({
      isbn: ['', Validators.required],
      title_id: ['', Validators.required],
      title: ['', Validators.required],
      purpose_id: ['', Validators.required],
      resolution_id: ['', Validators.required],
    });

    // Si lleva un parametro se extrae y se asigna
    if (this.paramTitle) {
      this.uploadForm.patchValue({
        isbn: this.paramTitle.isbn,
        title_id: this.paramTitle.title_id,
        title: this.paramTitle.title,
      });
    }

    if (this.paramStockId) {
      this.uploadForm.patchValue({
        stock_id: this.paramStockId
      });
    }

    // Se obtienen los catálogos
    this.getStocks();
    this.getPurposes();
  }

  /**
   * OnDestroy
   */
  ngOnDestroy(): void {
    if (this.stocksSubscription !== null) { this.stocksSubscription.unsubscribe(); }
    if (this.purposesSubscription !== null) { this.purposesSubscription.unsubscribe(); }
    if (this.resolutionsSubscription !== null) { this.resolutionsSubscription.unsubscribe(); }
  }

  filesDropped(files: FileHandle[]): void {
    this.files = files;
  }

  /**
   *
   */
  getStocks() {
    this.stocksSubscription = this.imageUploadService.getAllStocks().subscribe((result: Stock[]) => {
      this.stocks = result;
    }, (error) => {
      console.error(error.message);
    });
  }

  /**
   * 
   */
  onStockChange() {
    this.getResolutions();
  }

  /**
   *
   */
  getPurposes() {
    this.purposesSubscription = this.imageUploadService.getAllPurposes().subscribe((result: Purpose[]) => {
      this.purposes = result;
    }, (error) => {
      console.error(error.message);
    });
  }

  /**
   * 
   */
  onPurposeChange() {
    this.getResolutions();
  }

  /**
   *
   */
  getResolutions() {
    const purposeId = this.uploadForm.get('purpose_id').value;

    // 1 es el banco por default
    
    if (purposeId) {
      this.resolutionsSubscription = this.imageUploadService.getResolutions('1', purposeId).subscribe((result: Resolution[]) => {
        this.resolutions = result;
      }, (error) => {
        console.error(error.message);
      });
    } else {
      console.log('Falta selección');
    }
  }

  /**
   *
   */
  upload() {
    if (this.files.length !== 0) {
      this.imageUploadService.uploadImage(this.uploadForm.value, this.files).subscribe(response => {
        this.activeModal.close('Close click');
      }, (error) => {
        console.error(error);
        this.toastr.error(`Ha ocurrido un error al guardar la imagen, ${error}`, 'Error');
      });
    } else {
      this.toastr.error('Falta seleccionar o colocar la imagen', 'Campos Faltantes');
    }
  }
}
